import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=f64f0c4e&scoped=true&lang=pug"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"
import style0 from "./splash.vue?vue&type=style&index=0&id=f64f0c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64f0c4e",
  null
  
)

export default component.exports